import { render } from "./read-banner-skeleton.vue?vue&type=template&id=596eadfb&scoped=true"
import script from "./read-banner-skeleton.vue?vue&type=script&lang=js"
export * from "./read-banner-skeleton.vue?vue&type=script&lang=js"

import "./read-banner-skeleton.vue?vue&type=style&index=0&id=596eadfb&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596eadfb"]])

export default __exports__